import React from 'react';
import { useTranslation } from 'react-i18next';
import './CultivationLevelMap.css';

interface CultivationLevelMapProps {
  onClose?: () => void;
}

const cultivationLevelColors = [
  { color: '#7affc8', gradient: 'linear-gradient(135deg, #b8ffe6 0%, #00c486 100%)' },
  { color: '#7cb7ff', gradient: 'linear-gradient(135deg, #cfe4ff 0%, #1d73ff 100%)' },
  { color: '#ffc173', gradient: 'linear-gradient(135deg, #ffe4b3 0%, #ff8f1f 100%)' },
  { color: '#ffd95e', gradient: 'linear-gradient(135deg, #fff2b8 0%, #e2a100 100%)' },
  { color: '#ffa8ff', gradient: 'linear-gradient(135deg, #ffd2ff 0%, #d12ce0 100%)' },
  { color: '#ff9270', gradient: 'linear-gradient(135deg, #ffc9b3 0%, #ff4d1f 100%)' },
  { color: '#9dd2ff', gradient: 'linear-gradient(135deg, #d9ecff 0%, #3f9bff 100%)' },
  { color: '#7df7ff', gradient: 'linear-gradient(135deg, #c7fcff 0%, #00d2eb 100%)' },
  { color: '#ffc08a', gradient: 'linear-gradient(135deg, #ffe2c0 0%, #f58a1f 100%)' },
  { color: '#b4f0ff', gradient: 'linear-gradient(135deg, #e1f8ff 0%, #41c7ff 100%)' },
];

const cultivationIcons = ['🌱', '💨', '🏔️', '⚡', '🌟', '🔥', '☁️', '⚛️', '✨', '👑'];

const CultivationLevelMap: React.FC<CultivationLevelMapProps> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="cultivation-level-map">
      <div className="cultivation-header">
        <div className="cultivation-header-top">
          <div>
            <h2 className="cultivation-title">{t('cultivation.title')}</h2>
            <p className="cultivation-subtitle">
              {t('cultivation.subtitle')}
            </p>
          </div>
          {onClose && (
            <button
              type="button"
              className="cultivation-close-btn"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (onClose) {
                  onClose();
                }
              }}
              aria-label={t('cultivation.closeButton')}
            >
              ✕
            </button>
          )}
        </div>
      </div>

      <div className="cultivation-levels-container">
        {Array.from({ length: 10 }, (_, index) => {
          const levelId = index + 1;
          const colorInfo = cultivationLevelColors[index];
          const icon = cultivationIcons[index];

          return (
            <div
              key={levelId}
              className="cultivation-level-card"
              style={{
                '--level-color': colorInfo.color,
                '--level-gradient': colorInfo.gradient,
              } as React.CSSProperties}
            >
              <div className="level-number">{levelId}</div>
              <div className="level-icon">{icon}</div>
              <div className="level-content">
                <h3 className="level-name">{t(`cultivation.levels.${levelId}.name`)}</h3>
                <p className="level-description">{t(`cultivation.levels.${levelId}.description`)}</p>
              </div>
              <div className="level-glow" />
            </div>
          );
        })}
      </div>

      <div className="cultivation-footer">
        <p>{t('cultivation.footer')}</p>
      </div>
    </div>
  );
};

export default CultivationLevelMap;
